import i18n from "@/i18n";
import {
	HIDE_CONFIRMATION_DIALOG,
	RESET_STATES,
	SET_CONFIGURED_TURBINES,
	SET_CONFIRMATION_DIALOG_STATE,
	SET_SELECT_ALL_TURBINES,
	SET_SELECTED_REFERENCE_TURBINE,
	SET_SELECTED_TURBINES,
	SET_TURBINE_SEARCH,
	SHOW_CONFIRMATION_DIALOG
} from "./KinematicReplicatorActionsTypes";

export default {
	/**
   * Define a lista de turbinas que possuem configuração cinemática.
   * @param {Array<number>|Array<Object>} configuredTurbines Lista de turbinas configuradas.
   */
	[SET_CONFIGURED_TURBINES]({ commit }, configuredTurbines)
	{
		commit(SET_CONFIGURED_TURBINES, configuredTurbines);
	},

	/**
   * Exibe o diálogo de confirmação da replicação com título e texto localizados.
   */
	[SHOW_CONFIRMATION_DIALOG]({ commit })
	{
		const replicationTexts = {
			title: i18n.t("ConfirmationMessages.ReplicationTitle"),
			text:  i18n.t("ConfirmationMessages.ReplicationText"),
			show:  true
		};
		commit(SET_CONFIRMATION_DIALOG_STATE, replicationTexts);
	},

	/**
   * Esconde o diálogo de confirmação da replicação.
   */
	[HIDE_CONFIRMATION_DIALOG]({ commit })
	{
		commit(SET_CONFIRMATION_DIALOG_STATE, { show: false });
	},

	/**
   * Define a turbina de referência selecionada.
   * @param {Object} referenceTurbine Turbina de referência (ou null para limpar).
   */
	[SET_SELECTED_REFERENCE_TURBINE]({ commit }, referenceTurbine)
	{
		commit(SET_SELECTED_REFERENCE_TURBINE, referenceTurbine);
	},

	/**
   * Define os IDs das turbinas selecionadas.
   * @param {Array} selectedTurbineIds IDs das turbinas selecionadas.
   */
	[SET_SELECTED_TURBINES]({ commit }, selectedTurbineIds)
	{
		commit(SET_SELECTED_TURBINES, [ ...selectedTurbineIds ]);
	},

	/**
   * Define o estado do checkbox "Selecionar todos".
   * @param {boolean} selectAllIsActive Verdadeiro para marcar todos; falso para desmarcar.
   */
	[SET_SELECT_ALL_TURBINES]({ commit, getters }, selectAllIsActive)
	{
		const filteredTurbineIds =  selectAllIsActive ? getters.filteredTurbines.map(el => el.id) : [];
		commit(SET_SELECTED_TURBINES, [ ...filteredTurbineIds ]);
	},

	/**
   * Atualiza o termo de busca da turbina.
   * @param {string} valueToSearch Texto para filtrar turbinas.
   */
	[SET_TURBINE_SEARCH]({ commit }, valueToSearch)
	{
		commit(SET_TURBINE_SEARCH, valueToSearch);
	},

	/**
   * Restaura o estado do módulo para os valores padrão.
   */
	[RESET_STATES]({ commit })
	{
		commit(RESET_STATES);
	}
};